import type { InvestigationDb } from '../investigation/types';
import type { RasiTechDataStore } from '../store';
import type { RasiUserEvent } from '../userEventsStore';

import { centralFetch } from './client';
import { isCentralDbEnabled } from './config';
import { fetchCentralUserEvents } from './adminFetch';
import { mergeRemoteInvestigationSnapshot } from '../investigation/store';
import { mergeRemoteModDataSnapshot } from '../store';
import { mergeRemoteUserEvents } from '../userEventsStore';

type RemoteSnapshot<T> = { payload: T; updatedAt: number };

async function fetchSnapshot<T>(path: string): Promise<RemoteSnapshot<T> | undefined> {
  if (!isCentralDbEnabled()) return undefined;
  return centralFetch<RemoteSnapshot<T>>(path);
}

export async function pullRemoteUserData(userId: string): Promise<void> {
  if (!isCentralDbEnabled() || !userId) return;

  const [investigation, modData, events] = await Promise.all([
    fetchSnapshot<InvestigationDb>(`/investigation/snapshot/${userId}`),
    fetchSnapshot<Partial<RasiTechDataStore>>(`/mod-data/snapshot/${userId}`),
    fetchCentralUserEvents(userId, 500),
  ]);

  if (investigation?.payload) {
    await mergeRemoteInvestigationSnapshot(investigation.payload, investigation.updatedAt, userId);
  }

  if (modData?.payload) {
    await mergeRemoteModDataSnapshot(modData.payload, modData.updatedAt, userId);
  }

  if (events?.length) {
    await mergeRemoteUserEvents(events);
  }
}
